import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { FinancialReportReceiptSettings } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useFinancialReportReceiptSettingsPut = () => {
  const { t } = useTranslation();
  const branch = useBranchId();

  const update = useMutation({
    mutationFn: ({ item_id, ...rest }: FinancialReportReceiptSettings) =>
      put2(
        `/internal/secure/pos/v1/financials/print/settings/${branch}/${item_id}`,
        rest
      ),
    onSuccess: () => {
      toast.success(t("success.update"));
    },
  });
  return {
    update,
  };
};

export default useFinancialReportReceiptSettingsPut;
